



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { UPDATE_RECURRING_ORDER } from '@/queries/RecurringOrder';
import { formatRecurringOrderDataForMutation } from '@/app/RecurringOrder';
import { GQL_recurringOrder_recurringOrder } from '@/queries/__generated__/recurringOrder';
import { GQL_updateRecurringOrder, GQL_updateRecurringOrder_updateRecurringOrder_recurringOrder } from '@/queries/__generated__/updateRecurringOrder';
import DocumentControls from '../../Shared/DocumentControls.vue';
import { ORDER_NEW_DATA } from '@/queries/Order';
import {
  modifyOrderData,
  populateOrderWithUserNonChangeableCustomerInfo,
  populateOrderWithUserNonChangeableSupplierInfo,
} from '@/app/Order';
import { GET_CUSTOMER } from '@/queries/Customer';

@Component({
  components: {
    DocumentControls,
  },
})
export default class RecurringOrderEditControls extends Vue {
  @Prop(Object) public recurringOrder!: GQL_recurringOrder_recurringOrder;
  @Prop(Boolean) public validForm!: boolean;
  @Prop(Boolean) public dirtyForm!: boolean;
  private UPDATE_RECURRING_ORDER = UPDATE_RECURRING_ORDER;

  private resetFormDirty() {
    // We might have some watchers in action since we update a lot of data after the mutations,
    // ResetFormDirty-event should be emitted after the watchers are done.
    setTimeout(() => this.$emit(`reset-form-dirty`), 0);
  }

  private recurringOrderUpdated({ data }: { data: GQL_updateRecurringOrder}): void {
    if (!data.updateRecurringOrder?.recurringOrder) return;
    Object.assign<GQL_recurringOrder_recurringOrder, GQL_updateRecurringOrder_updateRecurringOrder_recurringOrder>(this.recurringOrder, modifyOrderData(data.updateRecurringOrder.recurringOrder));
    this.$sMessage.success(this.$t('Message.saveSuccess'));
    this.resetFormDirty();
  }

  private refreshParties() {
    this.$apollo.query({
      query: ORDER_NEW_DATA,
      fetchPolicy: 'no-cache',
    }).then(({ data }) => {
      populateOrderWithUserNonChangeableSupplierInfo(this.recurringOrder, data.currentUser.currentUnit);
    });

    if (this.recurringOrder.customer) {
      this.$apollo.query({
        query: GET_CUSTOMER,
        variables: { id: this.recurringOrder.customer.id },
        fetchPolicy: 'network-only',
      }).then(({ data }) => {
        populateOrderWithUserNonChangeableCustomerInfo(this.recurringOrder, data.customer);
      });
    }
  }

  private save(mutate: Function) {
    this.$emit(`save-button-click`);
    // We want to remove empty lines before saving.
    // However if we remove empty lines we trigger calculations to happen
    // in the next tick. This is why delay mutating by doing it in setTimeout.
    // This makes it be called after the calculations.
    setTimeout(() => {
      mutate({ variables: formatRecurringOrderDataForMutation({ order: this.recurringOrder }) });
    }, 0);
  }
}
